module.exports = __webpack_public_path__ + "static/img/6781_phase_function_Paper_Points.120f490.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6781_phase_function_Paper_Points.png
// module id = QEj7
// module chunks = 0